import Tr from 'translations/Translations';
import getObjectValue from "libs/getObjectValue";

const createItem = (titleKey, descriptionKey, id, elements = [], type = 'deafult') => ({
    title: Tr(titleKey),
    description: Tr(descriptionKey),
    id,
    elements,
    type
})

const createElement = (titleKey, descriptionKey, id, type = 'deafult') => ({
    title: Tr(titleKey),
    description: Tr(descriptionKey),
    id,
    type,
})

const elements = {
    s1: createItem('jedz_se_y_a_t', 'jedz_se_y_a_d', 's1', [
        createElement('jedz_se_y_a_1_t', 'jedz_se_y_a_1_d', 'selectionA1'),
        createElement('jedz_se_y_a_2_t', 'jedz_se_y_a_2_d', 'selectionA2'),
        createElement('jedz_se_y_a_3_t', 'jedz_se_y_a_3_d', 'selectionA3'),
        createElement('jedz_se_y_a_4_t', 'jedz_se_y_a_4_d', 'selectionA4'),
    ]),
    s2: createItem('jedz_se_y_b_t', 'jedz_se_y_b_d', 's2', [
        createElement('jedz_se_y_b_1_t', 'jedz_se_y_b_1_d', 'selectionB1'),
        createElement('jedz_se_y_b_2_t', 'jedz_se_y_b_2_d', 'selectionB2'),
        createElement('jedz_se_y_b_3_t', 'jedz_se_y_b_3_d', 'selectionB3'),
        createElement('jedz_se_y_b_4_t', 'jedz_se_y_b_4_d', 'selectionB4'),
        createElement('jedz_se_y_b_5_t', 'jedz_se_y_b_5_d', 'selectionB5'),
        createElement('jedz_se_y_b_6_t', 'jedz_se_y_b_6_d', 'selectionB6'),
        createElement('jedz_se_y_b_7_t', 'jedz_se_y_b_7_d', 'selectionB7'),
        createElement('jedz_se_y_b_8_t', 'jedz_se_y_b_8_d', 'selectionB8'),
    ]),
    s3: createItem('jedz_se_y_c_t', 'jedz_se_y_c_d', 's3', [
        createElement('jedz_se_y_c_1_t', 'jedz_se_y_c_1_d', 'selectionC1'),
        createElement('jedz_se_y_c_2_t', 'jedz_se_y_c_2_d', 'selectionC2'),
        createElement('jedz_se_y_c_3_t', 'jedz_se_y_c_3_d', 'selectionC3'),
        createElement('jedz_se_y_c_4_t', 'jedz_se_y_c_4_d', 'selectionC4'),
        createElement('jedz_se_y_c_5_t', 'jedz_se_y_c_5_d', 'selectionC5'),
        createElement('jedz_se_y_c_6_t', 'jedz_se_y_c_6_d', 'selectionC6'),
        createElement('jedz_se_y_c_7_t', 'jedz_se_y_c_7_d', 'selectionC7'),
        createElement('jedz_se_y_c_8_t', 'jedz_se_y_c_8_d', 'selectionC8'),
        createElement('jedz_se_y_c_9_t', 'jedz_se_y_c_9_d', 'selectionC9'),
        createElement('jedz_se_y_c_10_t', 'jedz_se_y_c_10_d', 'selectionC10'),
        createElement('jedz_se_y_c_11_t', 'jedz_se_y_c_11_d', 'selectionC11'),
        createElement('jedz_se_y_c_12_t', 'jedz_se_y_c_12_d', 'selectionC12'),
        createElement('jedz_se_y_c_13_t', 'jedz_se_y_c_13_d', 'selectionC13'),
        createElement('jedz_se_y_c_14_t', 'jedz_se_y_c_14_d', 'selectionC14'),
        createElement('jedz_se_y_c_15_t', 'jedz_se_y_c_15_d', 'selectionC15'),
        createElement('jedz_se_y_c_16_t', 'jedz_se_y_c_16_d', 'selectionC16'),
        createElement('jedz_se_y_c_17_t', 'jedz_se_y_c_17_d', 'selectionC17'),
        createElement('jedz_se_y_c_18_t', 'jedz_se_y_c_18_d', 'selectionC18'),
    ]),
    s4: createItem('jedz_se_y_d_t', 'jedz_se_y_d_d', 's4', [
        createElement('jedz_se_y_d_1_t', 'jedz_se_y_d_1_d', 'selectionD1'),
        createElement('jedz_se_y_d_2_t', 'jedz_se_y_d_2_d', 'selectionD2'),
    ]),
}

const elements2 = {
    n1: createItem('jedz_se_n_a_t', 'jedz_se_n_a_d', 'n1',
        [
            createElement('jedz_se_n_1_t', 'jedz_se_n_1_d', '1', 'disabled')],
        'disabled'),
}

export default {
    true: Object.values(elements),
    false: Object.values(elements2),
};

export const getInitValues = (sectionId, espdList, idPrefix) => {
    const item = elements[sectionId]
    return item.elements.reduce((prev, curr) => {
        return {
            ...prev,
            [curr.id]: getObjectValue(`${idPrefix}.${curr.id}`, espdList),
        }
    }, {})
}


